import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';

export const useEventCheckout = () => {
    const { postId } = useParams();

    const auth = useAuth();

    const [confirmGuest, setConfirmGuest] = useState(false);
    const [loading, setLoading] = useState(true);

    const onLogin = () => {
        localStorage.setItem('event', JSON.stringify({ postId }));

        auth.signinRedirect();
    };

    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated) {
            setLoading(false);
        }
    }, [auth.isLoading]);

    return {
        models: { postId, auth, confirmGuest, loading },
        operations: { setConfirmGuest, onLogin },
    };
};
